import axios from "axios";
import { getAccessToken, setAccessToken } from "./tokenService";
import { logout } from "@/redux/slices/auth/authSlice";
import { store } from "@/redux/store/store";

const baseURL = import.meta.env.VITE_API_BASE_URL;

const axiosInstance = axios.create({ baseURL });

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      setAccessToken(null);
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;

